const FITCHECK_SERVICE_URL = "https://o2ksqiwued.execute-api.us-east-1.amazonaws.com/dev";
// const FITCHECK_SERVICE_URL = "http://localhost:4200";
// const FITCHECK_SERVICE_URL = "http://localhost:3001";

export { FITCHECK_SERVICE_URL };
